<template>
    <div class="filter-period">
        <div class="filter-label" @click="showOptions = !showOptions">
            <span class="far fa-user"></span> {{ valueLabel }}
            <span
                v-if="this.value && allowReset"
                class="fa fa-close close"
                @click="reset()"
            ></span>
        </div>
        <div
            class="filter-options"
            v-if="showOptions"
            v-click-outside="clickedOutsideOptions"
        >
            <input
                type="text"
                v-model="searchString"
                class="form-control"
                :placeholder="t('reportFilters-search_action_placeholder')"
                @keyup="search"
                ref="searchInput"
                :name="name"
                :id="`filter-${name}`"
            />
            <ul>
                <li
                    v-for="automation in options"
                    :key="automation.id"
                    @click.prevent="
                        () => {
                            clicked = true;
                        }
                    "
                >
                    {{ automation.title }}
                </li>
            </ul>
            <div class="filter-actions">
                <button
                    type="button"
                    class="cancelBtn btn btn-sm btn-default"
                    @click="cancel"
                >
                    {{ t('reportFilters-close') }}
                </button>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
input {
    border: none;
    border-bottom: 1px solid #ddd;
    box-shadow: none;
    font-size: 13px;
    &:focus {
        outline: none;
        box-shadow: none;
        border: none;
        border-bottom: 1px solid #ddd;
    }
}
.filter-label {
    position: relative;
    .close {
        position: absolute;
        right: 0px;
        cursor: pointer;
        z-index: 10;
        padding: 5px;
    }
    .fa-user {
        margin-right: 5px;
    }
}
</style>
<script>
import keviApi from "../../../keviApi";
export default {
    name: "filter-client",
    props: {
        name: {
            type: String,
            default: "filter-client",
        },
        currentValue: {
            type: String,
            default: "",
        },
        allowReset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showOptions: false,
            clickedOutsideOptions: () => {},
            client: { clients_id: null, first_name: null, whatsapp: null },
            value: "",
            clicked: false,
            searchString: null,
            changedValue: false,
            searchTimeout: null,
            options: [],
        };
    },
    mounted() {
        if (this.currentValue) {
            this.value = this.currentValue;
            this.fetchClientInfo();
        }
        if (this.value.length > 0) {
            this.changed();
        }
        this.$root.$on("filter-client", (client) => {
            this.clicked = false;
            this.selectClient({ ...client, clients_id: client.id });
        });
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        fetchClientInfo() {
            let options = keviApi.getOptions(
                "place/client/" + this.value,
                "GET",
            );
            this.$http(options).then((response) => {
                this.client = {
                    clients_id: response.body.id,
                    first_name: response.body.first_name,
                    last_name: response.body.last_name,
                    whatsapp: response.body.whatsapp,
                };
            });
        },
        search() {
            if (this.searchString.length > 2) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                    let options = keviApi.getOptions("place/clients", "GET", {
                        page: 1,
                        search: this.searchString,
                        source: "clients-filter",
                    });
                    this.$http(options).then((response) => {
                        this.options = response.body.data;
                    });
                }, 400);
            }
        },
        selectClient(client) {
            this.client = client;
            this.value = client.clients_id;
            this.cancel();
        },
        isChecked(id) {
            return this.newValue.indexOf(id) !== -1;
        },
        cancel() {
            this.searchString = "";
            this.options = [];
            this.showOptions = false;
        },
        reset() {
            this.clicked = false;
            this.client = null;
            this.value = null;
        },
        changed() {
            this.$emit("changed", { value: this.value, clicked: this.clicked });
            this.clicked = false;
        },
    },
    computed: {
        valueLabel() {
            if (!this.value) {
                return this.t('reportFilters-select_client');
            }

            if (this.client.first_name) {
                return this.client.first_name + " " + this.client.last_name;
            }

            if (!this.client.first_name && this.client.whatsapp) {
                return this.client.whatsapp;
            }
            return "";
        },
    },
    watch: {
        showOptions() {
            if (this.showOptions) {
                window.setTimeout(() => {
                    this.$refs.searchInput.focus();
                }, 100);
                window.setTimeout(() => {
                    this.clickedOutsideOptions = () => {
                        if (this.showOptions) {
                            this.cancel();
                        }
                    };
                }, 100);
            } else {
                this.clickedOutsideOptions = () => {};
            }
        },
        value() {
            this.changed();
        },
        currentValue() {
            if (this.currentValue !== this.value) {
                this.value = this.currentValue;
                this.fetchClientInfo();
            }
        },
    },
};
</script>
